module.exports = __webpack_public_path__ + "static/media/site-cover-2.50c4f6ee.jpeg";